import { Box, Stack, Typography } from '@mui/material'
import type { FC, PropsWithChildren, ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

import { COLORS, unit } from '@hcr/ui'

import { LayoutNavigation, Metadata } from '../../../../common'

interface LayoutServicesProps extends PropsWithChildren {
  description: ReactNode
  title: ReactNode
}

export const LayoutServices: FC<LayoutServicesProps> = ({ children, description, title }) => {
  const { t } = useTranslation()
  return (
    <LayoutNavigation showContextMenuButton>
      <Metadata title={t('page-title.services')} />
      <Box paddingTop={unit(25.5)} paddingX={unit(6)} paddingBottom={unit(3)} bgcolor={COLORS.white}>
        <Stack gap={unit(4)}>
          <Typography component='h1' variant='headlineL'>
            {title}
          </Typography>
          <Typography component='h2' variant='bodyL'>
            {description}
          </Typography>
        </Stack>
        <Stack gap={unit(3)} marginTop={unit(9)}>
          {children}
        </Stack>
      </Box>
    </LayoutNavigation>
  )
}
